import type { ReactNode } from 'react';

export const symbol_swap_calls: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M200-320v-325q0-65 45-110t110-45q65 0 110 45t45 110v289q0 39 28 67t67 28q39 0 67-28t28-67v-324l-53 53q-9 9-22 9t-22-9q-9-9-9-22.5t9-22.5l106-107q5-5 10-7t11-2q6 0 11 2t10 7l107 107q9 9 9 22t-9 22q-9 9-22.5 9t-22.5-9l-53-52v324q0 65-45 110t-110 45q-65 0-110-45t-45-110v-289q0-39-28-67t-67-28q-39 0-67 28t-28 67v325l53-53q9-9 22.5-9t22.5 9q9 9 9 22.5t-9 22.5L251-221q-5 5-10 7t-11 2q-6 0-11-2t-10-7L102-328q-9-9-8.5-22.5T103-373q9-9 22.5-9t22.5 9l52 53Z"
		/>
	</svg>
);
